<template>
  <div class="field-preview">
    <div class="field-label">
      <span>{{ field.label }}</span>
      <v-chip x-small color="primary" class="ml-2" v-if="field.required">Required</v-chip>
      <v-chip x-small color="warning" class="ml-2" v-if="field.useAggregate">Auto-calculated</v-chip>
    </div>

    <v-select
      v-model="selectedValues"
      :items="selectItems"
      :multiple="isMultiSelect"
      :placeholder="field.hint || 'Select option...'"
      outlined
      dense
      chips
      :rules="fieldRules"
      :disabled="field.useAggregate"
      class="preview-input"
    ></v-select>

    <div class="field-description" v-if="field.description">
      <v-icon small color="grey">mdi-information-outline</v-icon>
      <span>{{ field.description }}</span>
    </div>

    <div class="options-preview mt-2" v-if="hasOptions">
      <div class="caption font-weight-medium mb-1">Available options:</div>
      <div class="options-list">
        <v-chip
          v-for="option in field.options"
          :key="option.id || option.value"
          small
          outlined
          class="mr-2 mb-2"
        >
          {{ option.label }}
        </v-chip>
      </div>
    </div>
  </div>
</template>

<script>
import { FieldType } from '@/shared/types/aperTemplate';

export default {
  name: 'SelectFieldPreview',
  props: {
    field: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedValues: null
    }
  },
  computed: {
    isMultiSelect() {
      return this.field.fieldType === FieldType.MULTI_SELECT;
    },
    hasOptions() {
      return this.field.options && this.field.options.length > 0;
    },
    selectedLabels() {
      if (!this.selectedValues || !this.hasOptions) return [];
      
      if (this.isMultiSelect) {
        return this.field.options
          .filter(option => this.selectedValues.includes(option.value))
          .map(option => ({ label: option.label, value: option.value }));
      } else {
        const option = this.field.options.find(opt => opt.value === this.selectedValues);
        return option ? [{ label: option.label, value: option.value }] : [];
      }
    }
  },
  created() {
    // Initialize as array for multi-select
    if (this.isMultiSelect) {
      this.selectedValues = [];
    }
  }
}
</script>

<style scoped>
.field-preview {
  display: flex;
  flex-direction: column;
}

.field-label {
  font-weight: 500;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}

.field-description {
  margin-top: 4px;
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  gap: 4px;
}

.options-preview {
  background-color: #f9f9f9;
  border-radius: 4px;
  padding: 8px;
}

.options-list {
  display: flex;
  flex-wrap: wrap;
}

.preview-input {
  opacity: 0.9;
}

.preview-input :deep(.v-input__slot) {
  min-height: 44px;
  cursor: default;
  background-color: #f5f7fa !important;
}
</style>
